import BlueTick from '@/components/elements/profile/BlueTick';
import WrapperLink from '@/components/link/WrapperLink';
import { DEFAULT_AVATAR } from '@/constant/avatar';
import { routerToBack } from '@/helpers/checkRouterPrevPath';
import { PATH_NAME } from 'configs/pathName';
import { PostContext } from 'context/PostContext';
import Avatar from 'design-system/components/Avatar/Avatar';
import { Divider } from 'design-system/components/Divider';
import Icon from 'design-system/components/Icon/Icon';
import { Typography } from 'design-system/components/Typography';
import { useRouter } from 'next/router';
import { forwardRef, useContext } from 'react';
import NewPostHeadJoinGroupBtn from './NewPostHeadJoinGroupBtn';

const NewPostHead = forwardRef<HTMLDivElement, {}>(function Foo(props, ref) {
  const { group, owner } = useContext(PostContext);
  const router = useRouter();

  const groupPathname = group?.slug;
  const profilePathname = owner.slug;

  const ownerAvatar = owner?.avatar || DEFAULT_AVATAR;
  const groupAvatar = group?.avatar || '/icons/default-group-avatar.svg';

  return (
    <div
      ref={ref}
      className="sticky top-[54px] z-50 w-full bg-white lg:top-[50px] xl:static xl:mt-6 xl:px-6"
    >
      <div className="mb-2 flex flex-1 items-center gap-2 pt-2 xl:gap-3 xl:pt-0">
        <Icon
          onClick={() => routerToBack(router, PATH_NAME.HOME)}
          iconName={'arrow-right-md'}
          className="text-Primary/Main xl:hidden"
        />
        <div className="relative flex h-auto min-w-[40px] max-w-[40px] items-center justify-center">
          <WrapperLink href={group ? groupPathname : profilePathname}>
            <Avatar
              alt={ownerAvatar ? 'group-avt' : 'owner-avt'}
              src={group ? groupAvatar : ownerAvatar}
              size={40}
              className="cursor-pointer"
              type={'image'}
              border
            />
          </WrapperLink>
          {group && (
            <WrapperLink
              href={profilePathname}
              anchorProps={{
                className:
                  'absolute bottom-[-10%] left-[calc(50%-20px/2+14px)] top-[60%] cursor-pointer',
              }}
            >
              <Avatar
                alt="owner-avt"
                src={ownerAvatar}
                size={20}
                type={'image'}
              />
            </WrapperLink>
          )}
        </div>
        <div className="h-auto flex-1 truncate">
          {group && (
            <WrapperLink href={groupPathname}>
              <Typography
                className="line-clamp-2 cursor-pointer whitespace-normal"
                variant="heading3"
              >
                {group?.name}
              </Typography>
            </WrapperLink>
          )}
          <WrapperLink
            href={profilePathname}
            anchorProps={{
              className: 'flex items-center gap-1',
            }}
          >
            <Typography
              style={{
                whiteSpace: 'break-spaces',
              }}
              className={[
                'line-clamp-2 w-fit cursor-pointer md:max-w-none',
                group && 'text-Action/Active',
              ].join(' ')}
              variant={group ? 'label' : 'heading3'}
            >
              {owner?.academicRank ? `${owner.academicRank}.` : ''}{' '}
              {owner?.name}
            </Typography>

            {owner?.hasBlueTick && <BlueTick />}
          </WrapperLink>
        </div>
        {group && <NewPostHeadJoinGroupBtn />}
      </div>
      <Divider type="horizontal" className="block xl:px-6" />
    </div>
  );
});

export default NewPostHead;
